import { Suspense } from "react";

import LoadingIcon from "@/assets/fallback/loading.svg";

type LoadingProviderProps = {
  children: React.ReactNode;
};

export default function LoadingProvider({ children }: LoadingProviderProps) {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            width: "var(--full-vw)",
            minHeight: "var(--full-vh)",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={LoadingIcon} width={100} height={100} alt="loading icon" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
